import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5020/api';

export const lookupAbn = async (abn) => {
  const res = await axios.get(`${API_BASE}/abn-lookup`, { params: { abn } });
  return res.data;
};
